export const Role = {
    Admin: '1',
    User: '0'    
}